const { Serializer } = require("jsonapi-serializer");

module.exports = {
  UpdateEnrollmentStateSerializer: (meta = {}) =>
    new Serializer("enrollment_state", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["enrollment_state"]
    })
};
